import type { AppType } from '@projections/api';
import { hc } from 'hono/client';
import { getApiBaseUrl } from './config';

/**
 * The typed Hono RPC client (PLAN.md Layer 3 — "type-safe client for free, no codegen").
 *
 * `hc<AppType>(baseUrl)` gives full route / param / response inference straight from the API's
 * exported `AppType` (`packages/projections-api/src/index.ts`) and the SHARED Zod contracts — no
 * OpenAPI, no generated client. Used by `planStore` for server persistence (and a future large-run
 * simulate path) when an API base URL is configured; when it is absent the app falls back to
 * localStorage and this client is never constructed.
 *
 * `@projections/api` is imported TYPE-ONLY for `AppType` here so none of the Worker's value code
 * (which is Worker-safe anyway, but irrelevant in the browser) is pulled in — only the route types.
 */
export type ApiClient = ReturnType<typeof hc<AppType>>;

/** Build the RPC client for the configured base URL, or `null` when none is set. */
export function createApiClient(): ApiClient | null {
  const base = getApiBaseUrl();
  if (base === null) return null;
  return hc<AppType>(base);
}
